import * as React from 'react';

// @ts-expect-error
import capitalize from 'underscore.string/capitalize';

import {getMultipleEntityType} from 'nutshell-core/utils/get-multiple-entity-type';

import {LinkedEntity} from 'shells/linked-entity/linked-entity';
import {DisplayOnlyTable} from 'shells/table/display-only-table';

import type {ListBulkActionsFragment} from 'nutshell-graphql-types';

import {EmptyState} from './empty-state';
import {useGetListBulkActions} from './hooks/use-get-list-bulk-actions';

type Props = {
    filterByUserId: string | null | undefined;
};

export function ListActionsTable(props: Props) {
    const {listBulkActions, isLoading, isFirstLoad, error} = useGetListBulkActions(
        props.filterByUserId || undefined
    );

    const columns = React.useMemo(
        () => [
            {
                id: 'user',
                Header: 'Name',
                accessor: (listBulkAction: ListBulkActionsFragment) => listBulkAction.actor,
                dataType: 'component',
                width: 150,
                hasLeftBorder: true,
                Cell: ({cell}: any) => <LinkedEntity {...cell.value} type='users' />,
            },
            {
                id: 'changeTime',
                Header: 'Date',
                accessor: (listBulkAction: ListBulkActionsFragment) => listBulkAction.changeTime,
                dataType: 'timestamp',
                width: 200,
            },
            {
                id: 'entityType',
                Header: 'List page',
                accessor: (listBulkAction: ListBulkActionsFragment) =>
                    capitalize(
                        getMultipleEntityType((listBulkAction.entityName || '').toLowerCase())
                    ),
                dataType: 'string',
                width: 200,
            },
            {
                id: 'changeType',
                Header: 'Action',
                accessor: (listBulkAction: ListBulkActionsFragment) =>
                    listBulkAction.changeType === 'EXPORT_INITIATED' ? 'Export' : 'Delete',
                dataType: 'string',
                width: 200,
            },
            {
                id: 'changes',
                Header: '# rows',
                accessor: (listBulkAction: ListBulkActionsFragment) =>
                    // @ts-expect-error
                    listBulkAction.changes[0].newValue,
                dataType: 'string',
                shouldTruncate: true,
                width: 150,
                hasRightBorder: true,
            },
        ],
        []
    );

    const specialStates = [
        {
            shouldRender: () =>
                !error && !listBulkActions.length && !isLoading && !props.filterByUserId,
            component: <EmptyState noun='list action' />,
        },
    ];

    return (
        <DisplayOnlyTable
            // @ts-expect-error
            columns={columns}
            data={listBulkActions}
            isLoading={isLoading}
            isFirstLoad={isFirstLoad}
            fullWidth={true}
            error={error}
            specialStates={specialStates}
            emptyStateText='This user hasn’t done any bulk actions on list pages'
        />
    );
}
